import { create } from 'zustand'

export type CatalogGameItem = { code: string; name: string; stream_count?: number }
export type CatalogStudioItem = {
  code: string
  name: string
  stream_count?: number
  lat?: number | null
  lon?: number | null
  country?: string | null
}
export type CatalogBrandItem = { code: string; name: string; stream_count?: number }
export type CatalogStreamItem = {
  stream_id: string
  type: string
  target_device: string
  stream_url: string | null
  url_masked?: string | null
  studio_code: string
  game_code: string
  brand_ids: string[]
  deleted_at?: string | null
  /** Present when fetched with `?telemetry=1`. */
  status?: 'online' | 'idle' | 'recently-offline' | 'never-seen' | null
  lastSeenMs?: number | null
}

interface CatalogStore {
  games: CatalogGameItem[]
  studios: CatalogStudioItem[]
  brands: CatalogBrandItem[]
  streams: CatalogStreamItem[]
  loaded: boolean
  setGames: (rows: CatalogGameItem[]) => void
  setStudios: (rows: CatalogStudioItem[]) => void
  setBrands: (rows: CatalogBrandItem[]) => void
  setStreams: (rows: CatalogStreamItem[]) => void
  setLoaded: (v: boolean) => void
}

export const useCatalogStore = create<CatalogStore>((set) => ({
  games: [],
  studios: [],
  brands: [],
  streams: [],
  loaded: false,
  setGames: (games) => set({ games }),
  setStudios: (studios) => set({ studios }),
  setBrands: (brands) => set({ brands }),
  setStreams: (streams) => set({ streams }),
  setLoaded: (loaded) => set({ loaded }),
}))

export function resolveStudioFromCatalog(
  raw: string,
  studios: CatalogStudioItem[],
): CatalogStudioItem | null {
  const key = String(raw ?? '').trim()
  if (!key) return null
  const byCode = studios.find((s) => s.code.toUpperCase() === key.toUpperCase())
  if (byCode) return byCode
  const norm = (s: string) => s.trim().toLowerCase().replace(/[_/]+/g, ' ').replace(/\s+/g, ' ')
  const byName = studios.find(
    (s) =>
      norm(s.name) === norm(key) ||
      norm(s.name).includes(norm(key)) ||
      norm(key).includes(norm(s.name)),
  )
  return byName ?? null
}
